import { render, staticRenderFns } from "./product-activity.vue?vue&type=template&id=02b3d0c6&scoped=true&"
import script from "./product-activity.vue?vue&type=script&lang=js&"
export * from "./product-activity.vue?vue&type=script&lang=js&"
import style0 from "./product-activity.vue?vue&type=style&index=0&id=02b3d0c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b3d0c6",
  null
  
)

export default component.exports